import React from 'react';
import { Link } from 'react-router-dom';
import categoryData from '../data/categories.json';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import CategoryGrid from '../components/custom-components/CategoryGrid';

const meta = {
    title: 'All Categories | Bagga International',
    meta: [
      { name: 'description', content: 'Browse all product categories from Bagga International. Find tool bags, pouches, belts, and more.' },
      { property: 'og:title', content: 'All Categories | Bagga International' },
      { property: 'og:description', content: 'Browse all product categories from Bagga International. Find tool bags, pouches, belts, and more.' },
      { property: 'og:image', content: '/images/site-default-og.jpg' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: 'https://baggainternational.com/categories' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'All Categories | Bagga International' },
      { name: 'twitter:description', content: 'Browse all product categories from Bagga International. Find tool bags, pouches, belts, and more.' },
      { name: 'twitter:image', content: '/images/site-default-og.jpg' }
    ],
    link: [
      { rel: 'canonical', href: 'https://baggainternational.com/categories' }
    ],
    style: [],
    script: [],
};

export default function Categories() {
    return (
        <React.Fragment>
            <HelmetProvider>
                <Helmet {...meta}></Helmet>
            </HelmetProvider>
            <CategoryGrid />  
        </React.Fragment>
    );
} 

// "categoryId": "leather-belt"
// "categoryId": "leather-double-tool-pouch"
// "categoryId": "leather-single-tool-pouch"
// "categoryId": "leather-tool-holder"
// "categoryId": "polyester-double-tool-pouch"
// "categoryId": "polyester-single-tool-pouch"
// "categoryId": "polyester-suspender-belt"
// "categoryId": "polyester-tool-bag"
// "categoryId": "polyester-tool-holder"
// "categoryId": "polyester-tool-roll"